var S3FileKind;
(function (S3FileKind) {
    S3FileKind["ROBOT_FLOW"] = "ROBOT_FLOW";
    S3FileKind["TASK_RAW"] = "TASK_RAW";
    S3FileKind["TASK_COMPILED"] = "TASK_COMPILED";
    S3FileKind["USER_PROFILE_PICTURE"] = "USER_PROFILE_PICTURE";
    S3FileKind["CUSTOMER_LOGO_PICTURE"] = "CUSTOMER_LOGO_PICTURE";
    S3FileKind["PRESENTATION_VIDEO"] = "PRESENTATION_VIDEO";
})(S3FileKind || (S3FileKind = {}));
export default S3FileKind;
